import React from 'react'
import { Typography } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

const { Text, Paragraph } = Typography

interface Props {
	label?: string
	value?: string | number | null
	className?: string
	classNameText?: string
	extra?: React.ReactNode
	validate?: boolean
	oneLine?: boolean
	toShowEmtpyValue?: boolean
	labelClassName?: string
}

const ReadOnlyField: React.FC<Props> = ({
	label,
	value,
	className,
	classNameText,
	extra,
	validate,
	labelClassName,
	oneLine = true,
	toShowEmtpyValue = false
}) => {
	if (!value && !toShowEmtpyValue) {
		return null
	}

	return (
		<div className={cl(styles.wrapper, className)}>
			{label && <Text className={cl(styles.label, labelClassName)}>{label}</Text>}
			<div
				title={value?.toString()}
				className={cl(styles.valueWrapper, { [styles.validate]: validate })}
			>
				{oneLine ? (
					<Text className={cl(styles.text, classNameText)} ellipsis>
						{value}
					</Text>
				) : (
					<Paragraph className={styles.paragraph}>{value}</Paragraph>
				)}
			</div>
			{extra && <div className={styles.extra}>{extra}</div>}
		</div>
	)
}

export default ReadOnlyField
